export default {
	"de": {
		"Search": "Suchen",
		"File type \"{0}\" is not allowed. Allowed file types: \"{1}\"": "Dateityp \"{0}\" ist nicht erlaubt. Erlaubte Dateitypen: \"{1}\"",
		"File": "Datei",
		"File size": "Dateigröße",
		"Last modified": "Letzte Änderung",
		"Remove all": "Alle entfernen",
		"Previous": "Zurück",
		"Next": "Weiter",
		"Close": "Schließen",
		"Open image in original size": "Bild in Originalgröße öffnen",
		"Download": "Herunterladen",
		"Allow Notifications": "Benachrichtigungen zulassen",
		"Please allow notifications to subscribe to push notifications": "Für Push-Benachrichtigungen müssen Benachrichtigungen zugelassen sein",
		"Notifications":"Benachrichtigungen",
		"Subscription of notifications was successful": "Benachrichtigungen wurden abonniert",
		"Subscription of notifications was cancelled": "Benachrichtigungen wurden abbestellt",
		"Subscription of notifications was <b>not</b> successful": "Benachrichtigungen konnten <b>nicht</b> abonniert werden",
		"Subscription of notifications was <b>not</b> cancelled": "Benachrichtigung konnte <b>nicht</b> abbestellt werden",
		"Expires on": "Läuft ab",
		"Created on": "Erstellt am",
		"Follow Link": "Link folgen",
		"No new notifications": "Keine neuen Hinweise",
		"Error occurred during upload": "Fehler beim Upload aufgetreten",
		"Unknown error occurred during upload. Please check log.": "Unbekannter Fehler beim Upload aufgetreten. Bitte Log prüfen.",
		"File type not allowed": "Dateityp ist nicht erlaubt",
		"{0} files selected, size: {1} KB": "{0} Dateien ausgewählt, Gesamtgröße: {1} KB"
	}
}
